import { View as ViewSchema } from "schemas/views";

export const getQuery = (key, schemaId, viewAsGuestBuyer) => {
    const url = viewAsGuestBuyer
        ? `/api/v3.0/view/${key}/schema/${schemaId}?viewAsGuestBuyer=true`
        : `/api/v3.0/view/${key}/schema/${schemaId}`;

    return {
        url: url,
        schema: ViewSchema,
        force: true,
    };
};
